<template>
    <div>
        <b-row>
            <b-col>
                <p class="mb-1">
                    
                    <font-awesome-icon icon="heart" class="text-danger" v-if="model.is_my_favorite" />
                    <font-awesome-icon :icon="[ 'far', 'heart' ]" v-if="!model.is_my_favorite" />
                    {{ model.count_favorites }}
                </p>
            </b-col>
            <b-col>
                <p class="mb-1">
                    <font-awesome-icon :icon="[ 'far', 'comment-alt-lines' ]" />
                    {{ model.count_comments }}
                </p>
            </b-col>
        </b-row>
        <p class="mb-1">
            <router-link :to="{ name: 'u.detail', params: { user_uuid: model.seller.uuid, }, }">{{ model.seller.name }}</router-link>
        </p>
        <p class="mb-1">
            {{ model.posted_at }}
        </p>
    </div>
<!--
        <b-col cols="12" class="flex-grow-1 flex-shrink-0 text-nowrap py-1" v-if="auth_id == model.user_id || auth_level >= '300'">
            <b-button-group size="sm" class="w-100">
                <b-button
                    :variant="$store.getters['answer/status2variant'](item)"
                    class="px-0"
                    style="flex: 1"
                    v-for="item in [ 'pending', 'sent', 'paid', 'completed', 'canceling', 'canceled', ]"
                    :key="item"
                    @click="$router.push({ name: 'answers', params: { form_uuid: model.uuid, status: item, } })"
                    >
                    <small>
                        <strong>
                            {{ trans.labels['form_answers.status.' + item] }}
                            <br>
                            {{ model.count[item] | baseNumberFormatter }}
                        </strong>
                    </small>
                </b-button>
            </b-button-group>

            <div class="text-center mt-2">
                <small><router-link :to="{ name: 'answers', params: { form_uuid: model.uuid }}">すべて</router-link></small>
            </div>
        </b-col>
    </b-row>
-->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_id',
            'auth_level',
            'trans',
        ])
    },
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>

